import React from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { FetchType } from '../../../enums';
import { DigitalSignatureType } from '../../../enums/digital-signature-type';
import { useAppActions } from '../../../overmind';
import { Button, Checkbox, FieldController, PhoneValidator, RequiredValidator, TextField } from '@keplerco/core';
import { IPdfReportModalProps } from './pdf-report.models';
import { Profile } from '../../../models/profile';

export function PDFReportModalLayout({ path, from, to, profile, onClick }: IPdfReportModalProps): JSX.Element {
  const actions = useAppActions();

  const { control, handleSubmit, getValues } = useForm({ mode: 'onBlur' });

  async function onSubmitHandler(fieldValues: FieldValues) {
    if (!profile) return;

    actions.startLoader({ path: path, type: FetchType.Sending });

    const request: Profile = {
      ...profile,
      phoneNumber: fieldValues.phoneNumber,
      cpdRegistrationNumber: fieldValues.cpdRegistrationNumber,
    };

    await actions.saveDigitalSignature(DigitalSignatureType.CpdActivityHonestyPledge);
    await actions.saveProfile(request);
    onClick();
  }

  return (
    <div className="modalContent">
      <header style={{ marginBottom: 30 }}>
        <h2>We'll need some info before we generate your report</h2>
      </header>

      <form id="saveDigitalSignature" onSubmit={handleSubmit(onSubmitHandler)}>
        <div className="card">
          <FieldController
            control={control}
            name="phoneNumber"
            rules={new PhoneValidator('Enter your contact number')}
            defaultValue={profile?.phoneNumber ?? ''}
            render={({ field, fieldState }) => {
              return <TextField {...field} label="Contact Number" type="number" responsive validation={{
                dirty: fieldState.isDirty || !!fieldState.error,
                invalid: !!fieldState.error,
                message: fieldState.error?.message ?? 'Enter your contact number',
              }} />;
            }}
          />

          <FieldController
            control={control}
            name="cpdRegistrationNumber"
            rules={new RequiredValidator('Enter your Professional body membership number')}
            defaultValue={profile?.cpdRegistrationNumber ?? ''}
            render={({ field, fieldState }) => {
              return <TextField {...field} label="Professional body membership number" type="text" responsive validation={{
                dirty: fieldState.isDirty || !!fieldState.error,
                invalid: !!fieldState.error,
                message: fieldState.error?.message ?? 'Enter your Professional body membership number',
              }} />;
            }}
          />

          <FieldController
            control={control}
            name="confirmHonesty"
            rules={new RequiredValidator('Complete your declaration')}
            render={({ field }) => {
              return (
                <Checkbox {...field} id="confirmHonesty" checked={getValues('confirmHonesty')}>
                  <span style={{ textAlign: 'start' }}>
                    I confirm that the information included in this report (including but not limited to learning related to Business, Personal, and Professional Ethics) is an accurate reflection of my CPD activities {!!from ? `from ${from} to ${to}` : `up to ${to}`}.
                  </span>
                </Checkbox>
              );
            }}
          />
        </div>

        <Button type="button" filled>
          Submit
        </Button>
      </form>
    </div>
  );
}
